import { useEffect } from 'react';
import { useAppDispatch } from '../../app/hooks';
import { observe } from '../../app/thunks/observe.thunk';

export const useObserving = () => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(observe());
	}, []);
};
